// --------------------------------------------- All Imports --------------------------------------------

import gsap from "gsap";
import { useEffect } from "react";
import image1 from "../../assets/images/Rectangle 102.png";
import image2 from "../../assets/images/Rectangle 104.png";
import image3 from "../../assets/images/Rectangle 105.png";
import image4 from "../../assets/images/Rectangle 106.png";
import tringle from "../../assets/images/tringle.png";
import walk from "../../assets/images/walk.png";

// --------------------------------------------- All Imports --------------------------------------------

const HeroSection = () => {
  // --------------------------------------------- Use Effect for animations (Hero Section) ----------------------------------------------------

  useEffect(() => {
    // ---------------------------------------------------- Rotate image animations ----------------------------------------------------

    gsap.fromTo(
      ".image",
      { opacity: 0, scale: 0, rotation: -160, borderRadius: "100%" },
      {
        opacity: 1,
        scale: 1,
        rotation: 0,
        duration: 2.5,
        ease: "power2.out",
        stagger: 0.3,
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".image", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".image", { borderRadius: "23px" });
          }
        },
      }
    );

    // ----------------------------------------------- Zoom-out effect for specific images -----------------------------------------------

    gsap.fromTo(
      ".zoom-out",
      { scale: 0, opacity: 0, filter: "blur(10px)", borderRadius: "100%" },
      {
        scale: 1,
        opacity: 1,
        filter: "blur(0px)",
        duration: 2.5,
        ease: "power2.out",
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".zoom-out", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".zoom-out", { borderRadius: "23px" });
          }

        },
      }
    );

    // ------------------------------------------ Zoom-out effect for specific images ------------------------------------------

    gsap.fromTo(
      ".ring-zoom-out",
      { scale: 0, opacity: 0, filter: "blur(50px)" },
      {
        scale: 1,
        opacity: 1,
        filter: "blur(0px)",
        yoyo: true,
        duration: 2.5,
        ease: "power2.out",
      }
    );

    // --------------------------------------- Animation for Image 4 with small height/width to full size + rotationX -------------------------------------------

    gsap.fromTo(
      ".rotate-x",
      {
        rotationX: -180,
        transformOrigin: "center center",
        opacity: 0,
        scale: 0,
        borderRadius: "100%",
      },
      {
        rotationX: 0,
        transformOrigin: "center center",
        opacity: 1,
        duration: 2.5,
        ease: "power2.out",
        scale: 1,
        repeatDelay: 0.8,
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".rotate-x", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".rotate-x", { borderRadius: "23px" });
          }
        },
      }
    );

    // --------------------------------------- Animation for text (left to right) ----------------------------------------

    gsap.utils.toArray(".text").forEach((text, index) => {
      gsap.fromTo(
        text,
        {
          opacity: 0,
          x: -200,
        },
        {
          opacity: 1,
          x: 0,
          duration: 2,
          delay: index * 0.5,
          ease: "power2.out",
        }
      );
    });

    // -------------------------------------------------  single Round Animation -------------------------------------------------

    gsap.fromTo(
      ".single-round",
      { scale: 0.3, borderRadius: "0" },
      {
        opacity: 1,
        scale: 1,
        duration: 3,
        ease: "power2.out",
        borderRadius: "50%",
      }
    );

    // ------------------------------------------------- round box animation -------------------------------------------------

    gsap.fromTo(
      ".gradBorder",
      { scale: 0.2, transformOrigin: "center center", borderRadius: "100%" },
      {
        transformOrigin: "center center",

        scale: 1,
        duration: 3,
        ease: "power2.out",
        borderRadius: "50px",
      }
    );

    gsap.to(".play", {
      scale: 1.2,
      duration: 1.5,
      ease: "power1.inOut",
      yoyo: true,
      repeat: -1,
    });
  }, []);

  // ---------------------------------------------------- rolling text button animation ----------------------------------------------------

  const handleMouseEnter = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 1,
      y: -100,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1.5,
      y: -50,
      ease: "power2.inOut",
      opacity: 1,
    });
  };

  const handleMouseLeave = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 0.5,
      y: 0,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1,
      y: 0,
      ease: "power2.inOut",
      opacity: 0,
    });
  };

  // ---------------------------------------------------- rolling text button animation ----------------------------------------------------

  return (
    <>
      {/* Main Hero Section */}
      <div className="text-white hero-section  mt-3 overflow-hidden relative -z-50 md:flex">
        {/* Left Content */}
        <div className="md:w-[45%] w-[100%] overflow-hidden">
          <div className="flex flex-col gap-[22px] lg:mt-[78px] md:mt-[67px] xs:mt-[40px] 2xl:ml-[4rem] xl:ml-20 md:ml-8 xs:ml-6">
            <p className="font-raleway font-medium xs:text-[16px] sm:text-[20px] md:text-[24px] lg:text-[30px] xl:text-[32px]">
              Since 2001
            </p>
            <h1 className="font-raleway font-medium xs:text-[18px] sm:text-[24px] lg:text-[32px] 2xl:text-[48px] xl:text-[40px]">
              Delivering Excellence in
            </h1>
            <div className="scroller font-faustina font-semibold 2200:text-[70px] lg:text-[60px] md:text-[45px] xs:text-[32px]">
              <span>
                IT Consulting
                <br />
                Wellness
                <br />
                Care Foundation
                <br />
                Education
                <br />
                Health Care
                <br />
                R & D
                <br />
                Adult Day Care
                <br />
                Product Services
              </span>
            </div>
          </div>

          {/* only md and lg) */}
          <div className="hidden md:block w-full h-auto overflow-hidden">
            <div className="ring-3 single-round 2xl:top-[51%] md:top-[45%] 2xl:-left-[14%] Txl:-left-[9%] xl:-left-[19%] lg:-left-[calc(229px+23px)] lg:top-[43%] md:-left-[33%] md:w-[84%] md:h-[78%] lg:w-[841px] lg:h-[778px] 2xl:w-[841px] 2xl:h-[778px] xl:w-[58%] xl:h-[77%]">
              <div className="w-full h-full relative -top-8 font-faustina ">
                <div className="box1 md:w-[180px] md:h-[85px] lg:w-[180px] lg:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[3%] lg:top-7 md:left-[40%] lg:left-[35%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] lg:text-[28px] leading-[33px] font-semibold">
                      200 +
                    </p>
                    <p className="md:text-lg lg:text-lg leading-[25px]">
                      Client Served
                    </p>
                  </div>
                </div>

                <div className="box2 md:w-[180px] md:h-[85px] lg:w-[180px] lg:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[20%] lg:top-28 md:right-[5%] lg:right-[11.5%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] lg:text-[28px] leading-[33px] font-semibold">
                      50000 +
                    </p>
                    <p className="md:text-lg lg:text-lg leading-[25px]">
                      PEOPLE HELPED
                    </p>
                  </div>
                </div>

                <div className="box3 md:w-[180px] md:h-[85px] lg:w-[180px] lg:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[45%] lg:top-80 md:left-[83%] lg:left-[85%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] lg:text-[28px] xs:text-[0px] leading-[33px] font-semibold">
                      20000 +
                    </p>
                    <p className=" md:text-lg lg:text-lg leading-[25px]">
                      STUDENT TRAINED
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="flex flex-col md:w-[55%] xs:w-[100%] md:gap-4 xs:gap-4 z-20 relative h-full px-8 mt-16">
          {/* Decorative Rings */}
          <div className="hidden md:block ring-1 ring-zoom-out absolute md:left-[17%] md:top-[1%] md:w-[325.47px] md:h-[231.93px] lg:left-[25%] lg:top-[0%] lg:w-[385.47px] lg:h-[281.93px] xl:left-[25%] xl:top-[10%] xl:w-[527px] xl:h-[380px] 2xl:left-[26%] 2xl:top-[10%] 2xl:w-[626px] 2xl:h-[476px]"></div>
          <div className="hidden md:block ring-2 ring-zoom-out absolute md:left-[59%] md:top-[0%] md:w-[400px] md:h-[478.2px] lg:left-[52%] lg:top-[0%] lg:w-[482.82px] lg:h-[546.36px] xl:left-[55%] xl:top-[10%] xl:w-[725px] xl:h-[720px] 2xl:left-[60%] 2xl:top-[10%] 2xl:w-[725px] 2xl:h-[733px]"></div>
          <div className="block md:hidden ring-1 ring-zoom-out absolute xs:left-[30%] xs:top-[4%] xs:w-[54%] xs:h-[15%] sm:left-[24%] sm:top-[2%] sm:w-[61%] sm:h-[20%]"></div>
          <div className="block md:hidden ring-2 ring-zoom-out absolute xs:left-[59%] xs:top-[2%] xs:w-[68%] xs:h-[29%] sm:left-[59%] sm:top-[2%] sm:w-[68%] sm:h-[35%]"></div>

          <div className="flex gap-5 items-end pt-10">
            <div className="image overflow-hidden xs:w-[55%] xs:h-[81%] xl:w-[56%] xl:h-[260px] md:w-[56%] md:h-[83%]">
              <img
                src={image2}
                alt="2"
                className="object-cover object-top w-full h-full"
              />
            </div>
            <div className="zoom-out overflow-hidden xs:w-[35%] xs:h-[135%] md:w-[46%] md:h-[130%] xl:w-[38%] xl:h-[362px]">
              <img
                src={image1}
                alt="1"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
          <div className="flex gap-5 pb-10">
            <div className="zoom-out overflow-hidden xs:w-[35%] xs:h-[135%] md:w-[46%] md:h-[130%] xl:w-[38%] xl:h-[362px]">
              <img
                src={image3}
                alt="3"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="rotate-x overflow-auto xs:w-[55%] xs:h-[81%] xl:w-[56%] xl:h-[260px]  md:w-[56%] md:h-[83%]">
              <img
                src={image4}
                alt="4"
                className="object-cover object-top w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* xs/sm only) */}
        <div className="block md:hidden w-full h-full overflow-hidden">
          <div className="ring-3 xs:top-[67%] sm:top-[60%] xs:left-[-72.4%] xs:w-[163.7%] xs:h-[55.2%] md:top-0 single-round">
            <div className="w-full h-full relative -top-16 font-faustina">
              <div className="box-wrapper xs:w-[20%] sm:top-[10%] xs:top-[14%] xs:h-[13%] absolute xs:left-[50%] z-10">
                <div className="box-content uppercase bg-black rounded-[16px] text-white flex flex-col gap-2 items-center justify-center h-full w-full relative">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="xs:text-[20px] sm:text-[25px] md:text-[40px] xs:leading-[20px] leading-[33px] font-semibold">
                      200 +
                    </p>
                    <p className="xs:text-xs sm:text-xl md:text-xl leading-[25px]">
                      Client Served
                    </p>
                  </div>
                </div>
              </div>


              {/* ------------------------------- BOX 2 ------------------------------- */}
              <div className="box2 p-[3px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[16px] xs:w-[20%] xs:top-[30%] xs:h-[13%] absolute xs:left-[75%] z-10">
                <div className="bg-black rounded-[16px] text-white flex flex-col gap-2 items-center justify-center h-full w-full uppercase">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="xs:text-[20px] sm:text-[25px] md:text-[40px] xs:leading-[20px] leading-[33px] font-semibold">
                      50000 +
                    </p>
                    <p className="xs:text-xs sm:text-xl md:text-xl leading-[25px]">
                      PEOPLE HELPED
                    </p>
                  </div>
                </div>
              </div>

              {/* ------------------------------- BOX 3 ------------------------------- */}
              <div className="box3 p-[3px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-2xl xs:w-[20%] xs:top-[55%] xs:h-[13%] absolute xs:left-[84%] z-10">
                <div className="bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center h-full w-full uppercase">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="xs:text-[20px] sm:text-[25px] md:text-[40px] xs:leading-[20px] font-semibold">
                      20000 +
                    </p>
                    <p className="xs:text-[10px] sm:text-lg md:text-xl leading-[25px]">
                      STUDENT TRAINED
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* "Our Success Speaks For Itself" Section */}
      <div className="flex md:flex-row flex-col w-full justify-center items-center text-[#EEEEEE] font-faustina lg:gap-[78px] md:gap-[48px] xs:gap-[35px] z-10 relative pt-[72px] pb-[40px] px-[25px]">
        <p className="font-semibold 1500:text-[60px] lg:text-[clamp(50px,4.8vw,80px)] 428:text-[clamp(30px,4.7vw,50px)] xs:text-[24px]  xs:leading-none md:leading-[80px] lg:leading-[100px]">
          Our Success Speaks For Itself
        </p>
        <a
          href="https://youtu.be/VaGsymiKZLg?si=j-fBd0hYEBUqw_Yj"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="flex gap-8 items-center cursor-pointer">
            <div className="play lg:w-[83px] lg:h-[83px] md:w-[60px] md:h-[60px] xs:w-[50px] xs:h-[50px] rounded-full flex justify-center items-center bg-gradient-to-r from-[rgb(31,162,255)] via-[rgb(18,216,250)] to-[rgb(166,255,203)]">
              <img
                src={tringle}
                alt="TriangleImage"
                className="lg:max-w-full lg:h-auto md:w-[30px] md:h-[30px] xs:w-[25px] xs:h-[25px]"
              />
            </div>
            <p className="font-normal xs:text-[clamp(20px,3.4vw,32px)]  lg:text-[32px] xs:leading-none md:leading-[80px] lg:leading-[100px]">
              PLAY NOW
            </p>
          </div>
        </a>

      </div>

      {/* "A Walk Through Us" Section */}
      <div className="w-full h-full flex justify-center items-center">
        {/* <div className="w-full flex justify-center items-center"> */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-center 1500:ml-[30px] lg:ml-[60px] md:ml-[20px] xs:ml-[16px] md:mr-[20px] xs:mr-[16px] lg:gap-[50px] md:gap-[30px] xs:gap-[36px]">
          {/* Text Content */}
          <div className="lg:w-[60%] md:w-[50%] xs:w-full flex flex-col justify-center items-center md:items-start text-center md:text-left gap-[40px]">
            <p className=" hidden md:block bg-gradient-to-r from-[#1FA2FF] via-cyan-300 to-[#A6FFCB] text-transparent bg-clip-text font-semibold lg:text-[56px] xs:text-[clamp(40px,5.8vw,56px)] font-faustina">
              A Walk Through Us
            </p>
            <div className="flex flex-col md:items-start xs:items-center lg:gap-[20px] xs:gap-[32px] text-white text-justify font-faustina font-normal 1920:text-[24px] lg:text-[20px] xs:text-[clamp(16px,1.9vw,20px)] leading-[35px]">
              <p>Running strong since 2001</p>
              <p>
                “At the end of the day, care is a human activity. Technology is not here to replace caregivers; it’s here to support them.”
              </p>
              <p>
                With this belief at heart, Param Group of Companies was founded by Mr. Vipul Amin in 2001 — driven by a vision to connect people with the best healthcare services through the power of technology. <br />

                What began as a simple idea — to use innovation to improve lives — has evolved into a global movement. Our unwavering vision continues to inspire us to achieve excellence and enhance human well-being. <br />

                At Param Group, we deliver transformative solutions across the education, healthcare, and IT industries. Today, we proudly stand as a globally recognized company with over two decades of impactful service and innovation. <br />
              </p>
              <div className="flex justify-start items-start w-full">
                <div className="flex justify-center items-center w-[155px] md:w-[170px] lg:w-[200px] text-center h-[62px]  bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                  <button
                    className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium xs:text-[18px] lg:text-[20px] diagonal text-center relative py-[16px] px-[52px]"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <span className="btn1 absolute transition-all top-[1px] left-0 w-full h-full flex justify-center items-center text-white">
                      Learn more
                    </span>
                    <span className="btn2 absolute transition-all opacity-0 top-[52px] left-0 w-full h-full flex justify-center items-center text-white">
                      Learn more
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Image Content */}
          <div className="md:w-[40%] xs:w-[80%] flex justify-center items-center">
            <img
              src={walk}
              alt="walk through"
              className=" object-contain"
            />
          </div>
          {/* Mobile Title */}
          <p className="block md:hidden bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text font-semibold text-[40px] text-center font-faustina">
            A Walk Through Us
          </p>
        </div>
        {/* </div> */}
      </div>
    </>
  );
};

export default HeroSection;
